export enum DomonetizationTypes {
  WHITE = "WHITE",
  BLACK = "BLACK"
}